import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { View } from '../../../../../shared/store/view/types';
import { KnownIpAddressModel } from '../../../../../shared/store/attendance/known-ip-address/types';
import { ActivatedRoute, Router } from '@angular/router';
import { SubHeaderService } from '../../../../../shared/store/subheader/subheader.service';
import { BreadcrumbService } from 'xng-breadcrumb';
import { ViewService } from '../../../../../shared/store/view/views.service';
import { KnownIpAddressService } from '../../../../../shared/store/attendance/known-ip-address/known-ip-address.service';
import { filter } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'app-known-ip-address-details',
  standalone: false,
  templateUrl: './known-ip-address-details.component.html',
  styleUrl: './known-ip-address-details.component.scss',
})
export class KnownIpAddressDetailsComponent implements OnInit, OnDestroy {
  knownIpAddress$: Observable<KnownIpAddressModel>;
  knownIpAddressId: number;
  view$: Observable<View>;

  constructor(
    private route: ActivatedRoute,
    private readonly router: Router,
    private readonly subHeaderService: SubHeaderService,
    private readonly breadcrumbService: BreadcrumbService,
    private readonly viewService: ViewService,
    private readonly knownIpAddressService: KnownIpAddressService,
  ) {
    this.knownIpAddress$ = this.knownIpAddressService.getById.value$;
    this.view$ = this.viewService.getViews.value$;
  }

  ngOnInit(): void {
    this.knownIpAddressId = this.route.snapshot.params['id'];
    this.knownIpAddressService.getById.call(this.knownIpAddressId);

    this.knownIpAddress$
      .pipe(
        untilDestroyed(this),
        filter((x) => !!x),
      )
      .subscribe((x) => {
        this.breadcrumbService.set('@details', x.address);
      });

    this.view$
      .pipe(
        untilDestroyed(this),
        filter((x) => !!x),
      )
      .subscribe((x) => {
        this.breadcrumbService.set('@list', x.title);
      });

    this.subHeaderService
      .getTriggerAction()
      .pipe(untilDestroyed(this))
      .subscribe((x) => {
        if (x == 'knownIpAddressEdit') {
          this.router.navigate([
            '/Configuration/KnownIpAddresses/Edit/',
            this.knownIpAddressId,
          ]);
        }
        if (x == 'knownIpAddressList') {
          this.router.navigate(['/Configuration/KnownIpAddresses/List/']);
        }
        this.subHeaderService.setTriggerAction('');
      });
  }

  ngOnDestroy(): void {
    this.knownIpAddressService.getById.reset();
    this.breadcrumbService.set('@details', ' ');
  }
}
